import React from 'react';
import { t } from 'Src/i18n';
import { UpsellsBlock } from 'Components/widgets/upsells-block/UpsellsBlock';
import { hasPersonRentedAnUpsell } from 'Views/booking/summary/SummaryView.utils';
type Props = {
  participants: ReadonlyArray<ProposalAttendeesType>;
  proposal: Proposal;
  isChild: boolean;
};
export const GetParticipantsActivities = ({ participants, proposal, isChild }: Props) => {
  return participants.map<Node>((person, index) => (
    <React.Fragment key={person.id}>
      {hasPersonRentedAnUpsell(
        [...proposal.additionalServices.activities, ...proposal.additionalServices.rentals],
        person.id,
      ) && (
        <p className="mb-10 mt-0 text-20 font-bold">
          {isChild
            ? `${t('booking.confirmation.child')} ${index + 1}`
            : `${t('booking.confirmation.adult')} ${index + 1}`}
        </p>
      )}
      <UpsellsBlock person={person} upsells={proposal.additionalServices.activities} />
      <UpsellsBlock person={person} upsells={proposal.additionalServices.rentals} />
    </React.Fragment>
  ));
};
